/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 27.04.2016.
 */
import Translate from './translate';

export default Translate;



// WEBPACK FOOTER //
// ./src/components/Translate/index.js